import { Check, CheckCircle, DirectionsRun, Pending, PauseCircleOutline, ReportGmailerrorredOutlined } from "@mui/icons-material"
import { Chip } from "@mui/material"

const StatusComponent = ({ status, id }) => {
  const getIcon = () => {
    switch (status) {
      case "In Process":
      case "Open":
        return <DirectionsRun />
      case "Completed":
        return <Check />
      case "Closed":
        return <CheckCircle />
      case "On Hold":
        return <PauseCircleOutline />
      case "Exception":
        return <ReportGmailerrorredOutlined />
    }

    return <Pending />
  }

  const getColor = () => {
    switch (status) {
      case "In Process":
      case "Open":
        return "info"
      case "Completed":
      case "Closed":
        return "success"
      case "Exception":
        return "error"
    }

    return "warning"
  }

  return <Chip style={{ marginLeft: 16 }} id={id} icon={getIcon()} label={status} color={getColor()} variant="outlined" />
}

export default StatusComponent
